export default "__VITE_ASSET__880b15bf__"